import type { TrackRow } from "#shared/schemas/trackQuery.ts";

/** Minimal track shape the player queue needs. */
export type QueueTrack = {
  id: string;
  uri: string;
  name: string;
  duration_ms: number | null;
  cover_url: string | null;
  artists: Array<{ name: string }>;
};

export type RepeatMode = "off" | "context" | "track";

export function queueTrackFromRow(row: TrackRow): QueueTrack | null {
  if (!row.uri) return null;
  return {
    id: row.id,
    uri: row.uri,
    name: row.name,
    duration_ms: row.duration_ms,
    cover_url: row.cover_url ?? row.album?.cover_url ?? null,
    artists: row.artists.map((a) => ({ name: a.name ?? "" })),
  };
}

export function formatPlayerTime(ms: number): string {
  const total = Math.max(0, Math.floor((ms || 0) / 1000));
  return `${Math.floor(total / 60)}:${String(total % 60).padStart(2, "0")}`;
}

export function artistsLabel(track: { artists: Array<{ name: string }> } | null): string {
  if (!track?.artists?.length) return "";
  return track.artists.map((a) => a.name).filter(Boolean).join(", ");
}
